import { render, staticRenderFns } from "./AgencyDetail.vue?vue&type=template&id=6c71abc8&scoped=true"
import script from "./AgencyDetail.vue?vue&type=script&lang=ts"
export * from "./AgencyDetail.vue?vue&type=script&lang=ts"
import style0 from "./AgencyDetail.vue?vue&type=style&index=0&id=6c71abc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71abc8",
  null
  
)

export default component.exports